
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reciter",
      function () {
        return require("private-next-pages/reciter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reciter"])
      });
    }
  